import { render, staticRenderFns } from "./PdfReader.vue?vue&type=template&id=990ddd46"
import script from "./PdfReader.vue?vue&type=script&lang=js"
export * from "./PdfReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports